import Sidebar from "../../../Components/Sidebar/Sidebar";
import SidebarGroup from "../../../Components/Sidebar/SidebarGroup";
import SidebarButton from "../../../Components/Sidebar/SidebarButton";
import { Sale, UserRole } from "../../../system/Domain";
import { useHistory, useParams } from "react-router";
import { CurrentSaleOrder } from "./SalesOrderPage";
import axios from "axios";
import ask from "../../../Dialogs/ask";
import useUser from "../../../system/useUser";
import moment from "moment";
import askForTextAnswer from "../../../system/askForTextAnswer";

interface Props {
	currentSaleOrder: CurrentSaleOrder | null
	onChange: (sale: Sale) => void
	canReclassifyExport: boolean
}

const SalesOrderSidebar = (props: Props) => {
	const history = useHistory();
	const { id } = useParams<{ id: string }>();
	const [, , hasRole, , hasAnyRole] = useUser();
	const isAdmin = hasRole(UserRole.AldAdmin);

	const handleBack = () => {
		history.push(`/sales/${id}`);
	};

	const handleSendMail = () => {
		history.push(`/sales/${id}/orders/${props.currentSaleOrder?.order.id}/send-documents`);
	};

	const handleCancelSales = async () => {
		const answer = await ask("Soll der Verkauf wirklich storniert werden?");
		if (answer.yes) {
			const { data: newSales } = await axios.post<Sale>(`/api/sales/${id}/cancel-order`, {
				orderId: null
			});
			props.onChange(newSales);
		}
	};

	const handleRevokeShipping = async () => {
		const answer = await ask("Soll die Auslieferung wirklich zurückgenommen werden?");
		if (answer.yes) {
			const { data: newSales } = await axios.post<Sale>(`/api/sales/${id}/revoke-shipping`, {
				revokingDate: moment()
			});
			props.onChange(newSales);
		}
	};

	const handleExportReclassification = async () => {
		const answer = await askForTextAnswer({
			text: "",
			title: "Soll der Exportverkauf wirklich umfaktoriert werden? Die Aktion kann nicht zurückgenommen werden.",
			label: "Begründung / Kommentar",
			required: true
		});

		if (answer) {
			const { data } = await axios.post<Sale>(`/api/sales/${id}/export/reclassify`, {
				comment: answer
			})

			props.onChange(data);
		}
	};

	const handleUndoExportReclassification = async () => {
		const answer = await ask("Soll die Umfaktorierung wirklich zurückgenommen werden?");

		if (answer.yes) {
			const { data } = await axios.put<Sale>(`/api/sales/${id}/export/reclassify/undo`);

			props.onChange(data);
		}
	};

	const handleShipVehicle = () => {
		history.push(`/vehicles/ship?saleId=${props.currentSaleOrder?.sale.id}`);
	};

	return (
		<Sidebar>
			<SidebarGroup>
				<SidebarButton
					onClick={handleBack}
				>
					Verkauf
				</SidebarButton>
				<SidebarButton onClick={handleSendMail}>
					Email
				</SidebarButton>
				{props.currentSaleOrder && props.currentSaleOrder.order.status !== "Cancelled" && (
					<SidebarButton
						onClick={handleCancelSales}
						disabled={!hasRole(UserRole.SalesAdmin)}
					>
						Verkauf stornieren
					</SidebarButton>
				)}
				{props.currentSaleOrder && props.currentSaleOrder.sale.status === "ReadyForShipping" && (
					<SidebarButton onClick={handleShipVehicle}>
						Fahrzeug ausliefern
					</SidebarButton>
				)}
				{hasAnyRole([UserRole.AldAdmin, UserRole.SalesAdmin]) && props.currentSaleOrder && props.currentSaleOrder.sale.status === "Shipped" && (
					<SidebarButton onClick={handleRevokeShipping}>
						Auslieferung zurücknehmen
					</SidebarButton>
				)}
			</SidebarGroup>
			<SidebarGroup>
				<SidebarButton onClick={handleExportReclassification} color="error" disabled={!props.canReclassifyExport}>
					Export Umfaktorierung
				</SidebarButton>
				{isAdmin && props.currentSaleOrder?.order?.export?.status === "Reclassified" && (
					<SidebarButton onClick={handleUndoExportReclassification} color="error">
						Export Umfaktorierung zurücknehmen
					</SidebarButton>
				)}
			</SidebarGroup>
		</Sidebar>
	);
};

export default SalesOrderSidebar;
